import {rei} from "@/services/api"
import store from "@/store"

export function getDocuments (key)  {
  const documents = [
    { key: "RG", label: "RG" },
    { key: "CTPS", label: "CTPS" },
    { key: "RNE", label: "RNE" },
    { key: "PASSAPORTE", label: "Passaporte" },
    { key: "TITULO_DE_ELEITOR", label: "Titulo de Eleitor" },
    { key: "CERT_DE_RESERVISTA", label: "Reservista" },
    { key: "CERT_DE_NASCIMENTO", label: "Certidão de Nascimento" },
    { key: "RIC", label: "RIC" },
    { key: "NIT", label: "NIT" },
    { key: "CNH", label: "CNH" },
    { key: "BENEFICIO_PREVIDENCIARIO", label: "Benefício Previdenciário" },
    { key: "CARTEIRA_DE_MARITIMO", label: "Carteira de Maritimo" },
    { key: "DOC_ESTRANGEIRO", label: "Documento Estrangeiro" },
    { key: "NAO_IDENTIFICADO", label: "Outros"}
  ]

  return key ? documents.find(doc => doc.key === key) : documents
}

export function getDocumentLabel (doc) {
  return getDocuments(doc).label || "Nâo Identificado"
}

export function getOrgaoEmissor () {
  return store.getters['repositorio/getOrgaoEmissor']
}
